var exports = {
  "E6": "ChannelEmbed.module__embed___bEI3Yz",
  "vO": "ChannelEmbed.module__embedFull___bEI3Yz",
  "UT": "ChannelEmbed.module__gridContainer___bEI3Yz",
  "Vg": "ChannelEmbed.module__grid___bEI3Yz",
  "$H": "ChannelEmbed.module__hasThumbnail___bEI3Yz",
  "zE": "ChannelEmbed.module__embedContent___bEI3Yz",
  "Cj": "ChannelEmbed.module__embedLink___bEI3Yz",
  "zC": "ChannelEmbed.module__embedProvider___bEI3Yz",
  "rN": "ChannelEmbed.module__embedAuthor___bEI3Yz",
  "QQ": "ChannelEmbed.module__embedAuthorName___bEI3Yz",
  "av": "ChannelEmbed.module__embedAuthorNameLink___bEI3Yz",
  "SG": "ChannelEmbed.module__embedAuthorIcon___bEI3Yz",
  "gt": "ChannelEmbed.module__embedTitle___bEI3Yz",
  "cD": "ChannelEmbed.module__embedDescription___bEI3Yz",
  "j0": "ChannelEmbed.module__embedFields___bEI3Yz",
  "Me": "ChannelEmbed.module__embedField___bEI3Yz",
  "$L": "ChannelEmbed.module__embedFieldName___bEI3Yz",
  "VN": "ChannelEmbed.module__embedFieldValue___bEI3Yz",
  "oy": "ChannelEmbed.module__embedFooterText___bEI3Yz",
  "W$": "ChannelEmbed.module__embedMedia___bEI3Yz",
  "ad": "ChannelEmbed.module__embedThumbnail___bEI3Yz",
  "te": "ChannelEmbed.module__embedFooter___bEI3Yz",
  "mG": "ChannelEmbed.module__embedFooterIcon___bEI3Yz",
  "i8": "ChannelEmbed.module__embedFooterSeparator___bEI3Yz",
  "PN": "ChannelEmbed.module__embedGifvContainer___bEI3Yz",
  "kL": "ChannelEmbed.module__container___bEI3Yz",
  "mQ": "ChannelEmbed.module__mediaFrame___bEI3Yz",
  "Mc": "ChannelEmbed.module__suppressButton___bEI3Yz",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___bEI3Yz",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___bEI3Yz",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___bEI3Yz",
  "$j": "ChannelEmbed.module__blueskyEngagement___bEI3Yz",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___bEI3Yz",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___bEI3Yz",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___bEI3Yz",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___bEI3Yz",
};

module.exports = exports;
